import { render, staticRenderFns } from "./BotTest.vue?vue&type=template&id=2cc9f7ac&"
import script from "./BotTest.vue?vue&type=script&lang=js&"
export * from "./BotTest.vue?vue&type=script&lang=js&"
import style0 from "./BotTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports